export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL as string;
export const API_BASE_IMAGE_URL = import.meta.env.VITE_API_BASE_IMAGE_URL as string;
export const API_BASE_WEB_SOCKET = import.meta.env.VITE_API_BASE_WEB_SOCKET as string;
export const API_BASE_URL_V2 = import.meta.env.VITE_API_BASE_URL_V2 as string; 


/* export const API_BASE_URL = "https://localhost:7086/api/v1";
export const API_BASE_IMAGE_URL = "https://localhost:7086";
export const API_BASE_WEB_SOCKET = "https://localhost:7086";
export const API_BASE_URL_V2 = "https://localhost:7086/api/v2";   */
